import { render } from "./MyProgram.vue?vue&type=template&id=224f35aa"
import script from "./MyProgram.vue?vue&type=script&lang=js"
export * from "./MyProgram.vue?vue&type=script&lang=js"

import exportComponent from "/Users/johnahnz0rs/0-PROJECTS/stackin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__